import { endOfDay, formatDateOnly } from '@myre/common-dates';

export const DWH_START_DATE = new Date(1900, 0, 1);
export const DWH_FORMATTED_START_DATE_ONLY = formatDateOnly(DWH_START_DATE);
export const DWH_END_DATE = endOfDay(new Date(2199, 11, 31));
export const DWH_FORMATTED_END_DATE_ONLY = formatDateOnly(DWH_END_DATE);
export const DWH_START_YEAR = DWH_START_DATE.getFullYear();
export const DWH_END_YEAR = DWH_END_DATE.getFullYear();
